import { AfterViewInit, Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslationService, I18nModule } from '@spartacus/core';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import InventoryManagementService from 'src/app/modules/custom-landing/inventory-unpublished-batch/inventory-management.service';
import { NgClass, NgIf, NgFor } from '@angular/common';
import { ShipmentStatusDirective } from '../shipment-status.directive';

@Component({
    selector: 'app-common-page-breadcrumbs',
    templateUrl: './common-page-breadcrumbs.component.html',
    styleUrls: ['./common-page-breadcrumbs.component.scss'],
    imports: [NgClass, RouterLink, NgIf, NgFor, ShipmentStatusDirective,I18nModule]
})
export class CommonPageBreadcrumbsComponent implements OnInit {
  @Input() pageTitle: string;
  @Input() navigationData: string;
  @Input() pageDetailTitle:string;
  chinaInstance: any;
  rte = false
  disp: any;
  constructor(private route: Router, private cd: ChangeDetectorRef, private customProductService: CustomProductsService, private translation: TranslationService, private inventoryService: InventoryManagementService) { }
  statusArray = { "ArrivedAtLoadPort": null, "BerthedAtLoadPort": null, "VesselSailed": null, "ArrivedAtDestination": null };
  status: any;
  isShipmentPage: any;
  isShipmentDetailPage: any;
  ngOnInit(): void {
    console.log(this.route);

    this.getbreadcrumbData();
    this.cd.detectChanges();
    if (this.route.url == '/opentenders') {
      this.rte = true
    } else {
      this.rte = false
    }
    this.customProductService.statusBarInput$.subscribe(res => {
      this.status = res;
    })
    this.customProductService.isShipmentPage$.subscribe(res => {
      this.isShipmentPage = res;
    })
    this.customProductService.isShipmentDetailPage$.subscribe(res => {
      this.isShipmentDetailPage = res;
    })
    const url=this.route.url
    if (this.route.url == '/shipmentvms/shipmentvmslist/portside' || this.route.url == '/shipmentvms/shipmentvmslist/portside?from=details' ) {
      this.disp = 'ship'
    }
    else if (this.route.url == '/batches/dvl-tracking-list') {
      this.disp = 'batch'
    }
    else if (this.route.url == '/bhpteam') {
      this.disp = 'team'
     
    }else if(this.route.url == '/shipmentinspection/shipmentinspectionlist/portside'){
      this.disp = 'inspectionShip';
    }else if(this.route.url == '/shipmentinspection/shipmentinspectionlist/bondedwarehouse'){
      this.disp = 'inspectionBondedwarehouse';
    }else if(this.route.url == '/dvl-screening-list/dvl-screening-list/portside'){
      this.disp = 'screeningPortside';
    }else if(this.route.url == '/dvl-screening-list/dvl-screening-list/bondedwarehouse'){
      this.disp = 'screeningBondedwarehouse';
    }else if(this.route.url == '/shipmentvms/shipmentvmslist/bondedwarehouse' || this.route.url == '/shipmentvms/shipmentvmslist/bondedwarehouse?from=details'){
       this.disp = 'bondedwarehouse';
    }else if(this.route.url == '/shipmentvms/quality-inspection'){
      this.disp = 'qualityInspection';
    }else if(this.route.url == '/bilateralCargos'){
      this.disp = 'bilateral';
    }
    else
      this.disp = 'home'
  
  }
 
  homeLinkClick(value): any {
    this.customProductService.getHomeLinkActive(value);
  }
  getbreadcrumbData() {
    // this.customProductService.getMasterData().subscribe((resp: any) => {
    //   this.chinaInstance = resp.chinaInstanceCheck;
    //   console.log(this.chinaInstance)
    //   this.cd.detectChanges();
    // });
  }
}
